// Ajax cart JS for Drawer and Cart Page
class quickShop extends HTMLElement {
  constructor() {
    super();

    this.closeBy = this.querySelector('.close-quickshop');

    //this.bindEvents(); 
    this.productTitle = undefined;
    this.includedVariantSkus = []; // Store included variant SKUs for re-application

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    document.addEventListener('Quickview:VariantChange',(e)=>{
      this.updateQuickshopSection(e.detail.variant);
      this.updatePersonalizeContent(e.detail.variant);
    });
    document.addEventListener('Quickview:OpenProduct',(e)=>{
      this.openQuickShop(e);
    });
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.querySelector('.close-quickshop').dispatchEvent(new Event('click'));
  }

  /**
   * Fetch Product data using handle
   * @param {*} handle 
   */
  async _loadQuickShop(handle,variant){
    let requestURL = '';
    if(variant){
      requestURL = `/products/${handle}?variant=${variant}&view=quickview`;
    }else{
      requestURL = `/products/${handle}?view=quickview`;
    }
    
    const response = await fetch(requestURL);
    
    const quickShopData = await response.text();
    
    return quickShopData;
  }

  /**
   * Open QuickShop modal and add focus to modal container
   *
   * @param {event} Event instance
   */
  openQuickShop(event) {
    event.preventDefault();
    event.stopPropagation();
    if(!event.detail.variant && !event.detail.handle) return;
    const handle = event.detail.handle;
    const selectedVariantId = event.detail.variant;
    const _this = event.detail.element;
    const includeVariantsSkus = event.detail.includeVariantsSkus;
    if(!handle) return;

    // Get included variant SKUs from the event detail
    const includedVariantSkus = includeVariantsSkus ? includeVariantsSkus.split(',').map(sku => sku.trim()) : [];
    this.includedVariantSkus = includedVariantSkus; // Store included variant SKUs for re-application
    this.innerHTML = '';
    this._loadQuickShop(handle,selectedVariantId).then(quickShopData => {
      let quickShopHTML = new DOMParser().parseFromString(quickShopData,'text/html');
      this.innerHTML = quickShopHTML.body.innerHTML;
      this.productTitle = quickShopHTML.querySelector('#component-quickshop-drawer').dataset.productTitle;
      let productJsonData = JSON.parse(quickShopHTML.querySelector('[data-productVariants]')?.innerHTML || {});
      let selectedVariant = productJsonData.find(variant => variant.id == selectedVariantId);

      // Show only included variants in the quick modal
      if (includedVariantSkus.length > 0) {
        this.showOnlyIncludedVariants(selectedVariant, productJsonData);
      } else {
        // Only apply selection logic if product has variants (not only default variant)
        const hasOnlyDefaultVariant = this.querySelector('.only-default-variant') !== null;
        if (!hasOnlyDefaultVariant) {
          // Clear pre-selected variants and initialize with no selection
          this.clearPreselectedVariants();
          this.initializeWithNoSelection();
        }
      }

      const productSidesElement = document.querySelector('[data-product-sides]');
      if (productSidesElement) {
        document.querySelectorAll('[data-product-sides] a').forEach(link => {
          const linkHandle = link.getAttribute("href")?.split("/products/")[1]?.split("/")[0];
          if (linkHandle === handle) {
            link.classList.add("active");
          }
        });
      }

      const drawer = this.querySelector('.custom-drawer');
      if (drawer) {
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
      }
      SiteOverlay.prototype.showOverlay();
      if(this.querySelector('.product-title')) Utility.forceFocus(this.querySelector('.product-title'));
      
      this.closeBy = this.querySelector('.close-quickshop');
      if(this.closeBy) this.closeBy.addEventListener('click', this.closeQuickShop.bind(this));

      const personalizeBtn = this.querySelector('[data-toggledrawer="component-personalization-drawer"]');
      if(personalizeBtn){
        this.producthandle = personalizeBtn.dataset.producthandle;
        personalizeBtn.addEventListener('click', this.openPersonalizationDrawer.bind(this));
      }
  
      Utility.trapFocus(this, this.closeBy);

      if(event){
        _this.setAttribute('aria-expanded', true);
      }

      lazyImageObserver.observe();
      collapsiblePanel.init();
    });
  }

  /**
   * Clear any pre-selected variants in quickview
   */
  clearPreselectedVariants() {
    const allInputs = this.querySelectorAll('input[type="radio"]');
    allInputs.forEach(input => {
      input.checked = false;
    });
  }

  /**
   * Initialize the quickview with no variant selected
   */
  initializeWithNoSelection() {
    // Set placeholder text for all option labels
    const optionLabels = this.querySelectorAll('.selected-option');
    optionLabels.forEach(label => {
      const placeholder = label.dataset.placeholder || 'Please select';
      label.textContent = placeholder;
      label.classList.add('placeholder-text');
    });
    
    // Disable the add to cart button with "Select All Options" message
    const productForm = this.querySelector('product-form');
    if (productForm && typeof productForm.toggleAddButton === 'function') {
      productForm.toggleAddButton('disable', false, true); // needsSelection = true
    }
    
    // Disable the personalize button too
    if (productForm && typeof productForm.togglePersonalizeButton === 'function') {
      productForm.togglePersonalizeButton(false);
    }
  }

  /**
   * Check if a variant is included based on its SKU
   * @param {String} sku - Variant SKU to check
   * @returns {Boolean} - True if variant is included
   */
  isVariantIncluded(sku) {
    if (!this.includedVariantSkus || this.includedVariantSkus.length === 0) return true; // If no filtering, show all variants
    return this.includedVariantSkus.includes(sku);
  }

  /**
   * Get available sizes for a specific color by checking SKUs
   * @param {String} colorValue - Color option value
   * @param {Array} productJsonData - Product variants data
   * @returns {Array} - Array of available size values
   */
  getAvailableSizesForColor(colorValue, productJsonData) {
    if (!this.includedVariantSkus || this.includedVariantSkus.length === 0) return [];
    const availableSizes = [];
    productJsonData.forEach(variant => {
      if (variant.options[0] === colorValue && this.isVariantIncluded(variant.sku)) {
        availableSizes.push(variant.options[1]);
      }
    });
    return availableSizes;
  }
  
  /**
   * 
   * @param {selected option} show only those images that are linked with selected option 
   * @returns 
   */
  updateQuickshopSection(currentVariant) {
    if (!currentVariant) return;
    const variantId = currentVariant.id;
    const productHandle = document.querySelector('#component-quickshop-drawer')?.dataset.productHandle;
    if (!productHandle) return;
    const section_id = document.querySelector('#component-quickshop-drawer .quickshop-product-info')?.dataset.sectionId;
    const url = `/products/${productHandle}?variant=${variantId}&section_id=${section_id}`;
    fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const newHtml = new DOMParser().parseFromString(responseText, 'text/html');
      if (this.includedVariantSkus && this.includedVariantSkus.length > 0) {
        const productJsonData = JSON.parse(newHtml.querySelector('[data-productVariants]')?.innerHTML || '[]');
        // Hide color swatches that have no available sizes
        const colorSwatches = newHtml.querySelectorAll('.color-swatch .swatch');
        colorSwatches.forEach(swatch => {
          const input = swatch.querySelector('input[type="radio"]');
          if (input) {
            const colorValue = input.value;
            const availableSizes = this.getAvailableSizesForColor(colorValue, productJsonData);
            if (availableSizes.length === 0) {
              swatch.closest('li')?.classList.add('d-none');
            }
          }
        });

        // Hide size swatches that are not available for the current color
        const sizeSwatches = newHtml.querySelectorAll('fieldset[name*="size"] .swatch');
        const currentColor = currentVariant.options[0];
        sizeSwatches.forEach(swatch => {
          const input = swatch.querySelector('input[type="radio"]');
          if (input) {
            const sizeValue = input.value;
            // Check if this size is available for the current color by finding the variant
            const variant = productJsonData.find(v => v.options[0] === currentColor && v.options[1] === sizeValue);
            const isAvailable = variant && this.isVariantIncluded(variant.sku);
            if (!isAvailable) {
              swatch.closest('li')?.classList.add('d-none');
            }
          }
        });
        if (document.querySelector(".quickshop-product-info .variant-section-wrapper") != null){
          document.querySelector(".quickshop-product-info .variant-section-wrapper").innerHTML = newHtml.querySelector(".quickshop-product-info .variant-section-wrapper").innerHTML;
        }
      }
      if(document.querySelector(".quickshop-product-info .product-images-wrapper") != null){
        document.querySelector(".quickshop-product-info .product-images-wrapper").innerHTML = newHtml.querySelector(".quickshop-product-info .product-images-wrapper").innerHTML;
      }
    })
    .catch(error => {
      console.error('Quickshop section update failed:', error);
    });
  }

  async openPersonalizationDrawer(event) {
    event.preventDefault();
    event.stopPropagation();
    const personalizationDrawer = document.getElementById('component-personalization-drawer');
    if (!personalizationDrawer) return;

    // Close quickshop drawer
    const quickshopDrawer = this.querySelector('.custom-drawer');
    if (quickshopDrawer) {
      quickshopDrawer.classList.remove('open');
      quickshopDrawer.setAttribute('aria-hidden', 'true');
    }

    // Open personalization drawer
    personalizationDrawer.classList.add('open');
    personalizationDrawer.setAttribute('aria-hidden', 'false');

    // Add close event listener to personalization drawer close button
    const closeBtn = personalizationDrawer.querySelector('[data-closedrawer]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        personalizationDrawer.classList.remove('open');
        personalizationDrawer.setAttribute('aria-hidden', 'true');
        // Reopen quickshop drawer
        if (quickshopDrawer) {
          quickshopDrawer.classList.add('open');
          quickshopDrawer.setAttribute('aria-hidden', 'false');
        }
      }, { once: true });
    }
  }
  /**
   * Update personalize options when quick view is changed. 
   */
    updatePersonalizeContent(variant){
      if (!variant) return;
      this.personalizationDrawer = document.querySelector('#component-personalization-drawer');
      if (!this.personalizationDrawer) return;
      const url = `/products/${this.producthandle}?variant=${variant.id}`;
      this.renderPersonalizationDrawer({
        requestUrl: `${url}?sections=template-product`,
        variant: variant
      });
    }
  
    renderPersonalizationDrawer({ requestUrl, variant }) {
      fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newDrawerContent = html.querySelector('#component-personalization-drawer .drawer-wrapper');
          if (newDrawerContent) {
            const currentDrawerContent = this.personalizationDrawer.querySelector('.drawer-wrapper');
            currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
          }
        })
        .catch((error) => {
          console.error('Error updating personalization drawer:', error);
        });
    }

  /**
   * Show only included variants and handle automatic selection of available variants
   * @param {Object} selectedVariant - Currently selected variant
   * @param {Array} productJsonData - Product variants data
   */
  showOnlyIncludedVariants(selectedVariant, productJsonData) {
    const colorSwatchFieldset = this.querySelector('.color-swatch');
    if (!colorSwatchFieldset) return;
    const colorSwatches = colorSwatchFieldset.querySelectorAll('.swatch');
    let selectedVariantChanged = false;
    let newSelectedVariant = null;

    // Process color swatches
    colorSwatches?.forEach(swatch => {
      const input = swatch.querySelector('input[type="radio"]');
      if (input) {
        const colorValue = input.value; // This will be RED, BLACK, etc.
        const availableSizes = this.getAvailableSizesForColor(colorValue, productJsonData);
        // If no sizes are available for this color, hide the color swatch
        if (availableSizes.length === 0) {
          swatch.closest('li').style.display = 'none';
          // If this was the selected variant, we need to select a different one
          if (input.checked) {
            selectedVariantChanged = true;
            // Find the first available color with available sizes
            const availableSwatches = Array.from(colorSwatches).filter(s => {
              const sInput = s.querySelector('input[type="radio"]');
              if (!sInput) return false;
              const sColorValue = sInput.value;
              const sAvailableSizes = this.getAvailableSizesForColor(sColorValue, productJsonData);
              return sAvailableSizes.length > 0;
            });
            if (availableSwatches.length > 0) {
              const firstAvailableInput = availableSwatches[0].querySelector('input[type="radio"]');
              const firstAvailableLabel = availableSwatches[0].querySelector('label');
              if (firstAvailableInput && firstAvailableLabel) {
                input.checked = false; // Uncheck the current one
                firstAvailableInput.checked = true; // Check the first available one
                // Update the selected option display
                const selectedOptionElement = this.querySelector('[data-option-type="color"]');
                if (selectedOptionElement) {
                  selectedOptionElement.textContent = firstAvailableLabel.title || firstAvailableInput.value;
                }
                // Find the new variant to select (first available size for this color)
                const newColorValue = firstAvailableInput.value;
                const newAvailableSizes = this.getAvailableSizesForColor(newColorValue, productJsonData);
                if (newAvailableSizes.length > 0) {
                  // Find the new variant to select
                  newSelectedVariant = productJsonData.find(variant => 
                    variant.options[0] === newColorValue && variant.options[1] === newAvailableSizes[0]
                  );
                }
              }
            }
          }
        }
      }
    });

    // Process size swatches based on current color selection
    const sizeSwatchFieldset = this.querySelector('fieldset[name*="size"]');
    if (sizeSwatchFieldset) {
      const sizeSwatches = sizeSwatchFieldset.querySelectorAll('.swatch');
      const currentColor = selectedVariant.options[0];
      sizeSwatches?.forEach(swatch => {
        const input = swatch.querySelector('input[type="radio"]');
        if (input) {
          const sizeValue = input.value; // This will be YOUTH, ADULT, etc.
          // Check if this size is available for the current color by finding the variant
          const variant = productJsonData.find(v => v.options[0] === currentColor && v.options[1] === sizeValue);
          const isAvailable = variant && this.isVariantIncluded(variant.sku);
          if (!isAvailable) {
            swatch.closest('li').style.display = 'none';
            // If this was the selected variant, we need to select a different one
            if (input.checked) {
              selectedVariantChanged = true;
              // Find the first available size for the current color
              const availableSizes = this.getAvailableSizesForColor(currentColor, productJsonData);
              if (availableSizes.length > 0) {
                const firstAvailableSize = availableSizes[0];
                const firstAvailableInput = Array.from(sizeSwatches).find(s => {
                  const sInput = s.querySelector('input[type="radio"]');
                  return sInput && sInput.value === firstAvailableSize;
                })?.querySelector('input[type="radio"]');
                if (firstAvailableInput) {
                  input.checked = false; // Uncheck the current one
                  firstAvailableInput.checked = true; // Check the first available one
                  // Update the selected option display
                  const selectedOptionElement = this.querySelector('[data-option-type="size"]');
                  if (selectedOptionElement) {
                    selectedOptionElement.textContent = firstAvailableInput.value;
                  }
                  // Find the new variant to select
                  newSelectedVariant = productJsonData.find(variant => 
                    variant.options[0] === currentColor && variant.options[1] === firstAvailableSize
                  );
                }
              }
            }
          }
        }
      });
    }
    
         // If we changed the selected variant, trigger the update
     if (selectedVariantChanged && newSelectedVariant) {
       this.updateVariantSelection(newSelectedVariant);
     }

   }

  /**
   * Update variant selection and trigger necessary updates
   * @param {Object} newSelectedVariant - The new variant to select
   */
  updateVariantSelection(newSelectedVariant) {
    // Update the hidden input for form submission
    const variantInput = this.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = newSelectedVariant.id;
    }
    
    // Update SKU display
    const skuElement = this.querySelector('[data-event-variant-sku]');
    if (skuElement) {
      skuElement.textContent = newSelectedVariant.sku;
    }
    
    // Update price display
    const currentPriceElement = this.querySelector('[data-currentprice]');
    const comparePriceElement = this.querySelector('[data-compareprice]');
    if (currentPriceElement) {
      currentPriceElement.textContent = newSelectedVariant.price ? `$${(newSelectedVariant.price / 100).toFixed(2)}` : '';
    }
    if (comparePriceElement && newSelectedVariant.compare_at_price) {
      comparePriceElement.textContent = `$${(newSelectedVariant.compare_at_price / 100).toFixed(2)}`;
    } else if (comparePriceElement) {
      comparePriceElement.style.display = 'none';
    }

    // Trigger variant change event to update images and other components
    const variantChangeEvent = new CustomEvent('Quickview:VariantChange', {
      detail: {
        variant: newSelectedVariant
      }
    });
    document.dispatchEvent(variantChangeEvent);
  }

  /**
   * Open QuickShop and Remove focus from modal container
   *
   * @param {event} Event instance
   */
  closeQuickShop(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();

      const drawer = this.querySelector('.custom-drawer');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.classList.remove('open');
      }
      this.innerHTML = '';
      // Clear included variant SKUs data when closing
      this.includedVariantSkus = [];
      SiteOverlay.prototype.hideOverlay();
      let openByEle = document.querySelector('.quickshop--button[aria-expanded="true"]');
      openByEle.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);
      Utility.forceFocus(openByEle);
    }
  }
}
customElements.define("quick-shop", quickShop);
  